var map = {
	"./print_format_de.png": 54383,
	"./print_format_en.png": 42531,
	"./print_format_es.png": 84550,
	"./print_format_fr.png": 64010,
	"./print_format_it.png": 96901,
	"./print_format_ja.png": 49317,
	"./print_format_ru.png": 80137,
	"./print_format_zh.png": 91972
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25337;